import Vue from 'vue';
import { Emit, Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import EdInputModel from '@/models/ed-input.model';

@Component({
  name: 'ed-confirm-message',
  components: {
  }
})
export default class EdConfirmMessageComponent extends Vue {

  @Prop() readonly params: any;

  dontAskAgaingTeaherOnly: any = EdInputModel('acceptTerms', false, {}, true);

  confirmMessage() {
    this.params.onConfirmMessage(this.dontAskAgaingTeaherOnly.value);
    this.closeModal();
  }

  cancelMessage() {
    this.dontAskAgaingTeaherOnly.value = false;
    this.closeModal();
  }

  closeModal() {
    this.$EdModal.closeModal();
  }
}
